import React from "react";
import Checkbox from "@mui/material/Checkbox";
import notSelectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox.svg";
import selectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox2.svg";

const CustomCheckbox = (props) => {
  const { data } = props;
  return (
    <Checkbox
      onChange={() => props.handleClick(data.id)}
      checked={data.isSelected}
      inputProps={{
        "aria-labelledby": `enhanced-table-checkbox-${data.id}`,
      }}
      icon={<img src={notSelectedCheckboxIcon} alt="checkbox" />}
      checkedIcon={<img src={selectedCheckboxIcon} alt="checkbox" />}
    />
  );
};

export default React.memo(CustomCheckbox);
